<section class="service-page">
  <div class="row pad">
    <div class="service-page__inner">
      <div class="text-muted">1st November 2025</div>

      <h1>Terms of Use</h1>

      <p>
        Access to and use of this website is provided by AE EventsCo Holdings
        LLC subject to the following terms and conditions.
      </p>

      <h2>1. Acceptance</h2>
      <p>
        <a href="https://www.marigrp.com" target="_blank">www.marigrp.com</a>
        (the “Website”) is a website operated by AE EventsCo Holdings LLC or one
        of its subsidiaries (AE EventsCo Holdings LLC and its subsidiaries and
        affiliates, collectively, “Mari Group”). Mari Group is a limited
        liability company based in California at 8383 Wilshire Blvd, Suite 400,
        Beverly Hills, CA 90211. By visiting and using the Website, you agree,
        without limitation or qualification, to be bound by these terms and
        conditions of use (the “Terms of Use”), the Mari Group Privacy Policy
        (the “Privacy Policy”) and the Mari Group Cookie Policy (the “Cookies
        Policy”) incorporated herein by reference. Where permitted by local law,
        Mari Group reserves the right to modify or revise the Terms of Use, in
        its sole discretion, at any time. By visiting and using the Website, you
        agree to be bound by any and all subsequent modifications or revisions
        and to comply with any applicable laws and regulations. We recommend
        that Website users review the most up-to-date version of the Terms of
        Use periodically. We do not guarantee that the Website, or the Contents
        (as described in more detail below), will always be available or be
        uninterrupted. We may suspend, withdraw, discontinue, or change all or
        any part of the Website without notice. We will not be liable to you if
        for any reason the Website is unavailable at any time or for any period.
        You are responsible for making all arrangements necessary for you to
        have access to the Website. You are also responsible for ensuring that
        all persons who access the Website through your internet connection are
        aware of these Terms of Use and other applicable terms and conditions,
        and that they comply with them. The materials provided on the Website
        are protected by applicable law, including, but not limited to, United
        States copyright laws and international treaties.
      </p>

      <h2>2. Personal Information</h2>
      <p>
        The personal information you submit to Mari Group and which is collected
        from you is governed by the Mari Group Privacy Policy and Cookie Policy.
        To the extent there is an inconsistency between these Terms of Use and
        the Privacy Policy and/or Cookie Policy, the Privacy Policy and/or
        Cookie Policy, as applicable, shall govern. You are responsible for
        providing information that is accurate, current and complete. If you
        provide information that is not accurate, current, or complete, or if
        Mari Group has reason to believe that information you provided is not
        accurate, current or complete, Mari Group has the right to prohibit you
        from any and all future use of the Website.
      </p>

      <h2>3. Use Restrictions</h2>
      <p>
        The content on the Website, such as text, graphics, images, photographs,
        illustrations, trademarks, trade names, service marks, logos,
        information obtained from Mari Group licensors, and other materials (the
        “Contents”) is protected by intellectual property rights under both
        United States and foreign laws. Ownership of the Contents – in other
        words, ownership of all intellectual property rights in such Contents –
        remains with Mari Group or our licensors. All rights not expressly
        granted herein are reserved to Mari Group and its licensors. If you
        violate any of these Terms of Use, your permission to use the Contents
        automatically terminates and you must immediately destroy any copies you
        have made of any portion of the Contents. Any use of the Contents not
        expressly permitted by these Terms of Use is a breach of these Terms of
        Use and may violate copyright, trademark, and other laws. Except as
        otherwise stated herein, you may not, without Mari Group’s written
        permission, “mirror” any Contents contained in the Website or any other
        server and you agree not to reproduce, duplicate, copy, sell, resell or
        exploit for any commercial purpose, any portion of the Website or the
        Contents other than as expressly authorized by Mari Group in writing.
        You may not use the Website for any purpose that is unlawful or
        prohibited by these Terms of Use, including to defame, harass, stalk,
        threaten, abuse, or otherwise violate the rights of a third party as
        defined by applicable law. Mari Group authorizes you to view and
        download a single copy of the Website and Contents. You agree that you
        will not remove or modify any acknowledgements, credits or legal notices
        contained on the Website or in the Contents. Where applicable, you shall
        include the following copyright notice: “Copyright © 2025, Mari Group.
        All rights reserved”. Any special rules for the use of other items
        provided on the Website may be included elsewhere within the Website and
        are incorporated into these Terms of Use by reference. The use of the
        Contents on any other site or in a networked computer environment for
        any purpose is prohibited. You may not use the Website in any manner
        that could damage, disable, overburden or impair the Website, or
        interfere with any other party’s use and enjoyment of the Website. You
        may not attempt to gain unauthorized access to the Website through
        hacking, password mining, or any other means. Mari Group reserves the
        right, in its sole discretion, to terminate your access to the Website,
        or any portion thereof, at any time, if there is a justifiable reason,
        without prior notice or any notice. If, for any reason, you create any
        derivatives, modifications, or improvements to the Contents
        (“Derivatives”), all right, title, and interest (including existing and
        future intellectual property rights) in such Derivatives (“Derivative
        Rights”) vest in Mari Group immediately upon creation. You hereby assign
        to Mari Group with full title guarantee all right, title, and interest
        in all such Derivative Rights. You represent and warrant that use by
        Mari Group or its licensees of the Derivative Rights will not infringe
        the intellectual property rights or other rights of any third party. You
        must do all things and sign all documents necessary or desirable to give
        effect to this paragraph.
      </p>

      <h2>4. Submission of Ideas</h2>
      <p>
        Mari Group does not accept submissions of any kind through the Website
        (e.g., materials, ideas, suggestions, know-how, or concepts, other than
        those expressly sought through permitted use of the Website) or
        otherwise. All submissions, other than those expressly sought through
        permitted use of the Website, may be deleted unread or destroyed, at
        Mari Group’s discretion. You hereby grant to Mari Group an irrevocable,
        perpetual, royalty-free license (including the right to sublicense to
        third parties) to exercise the intellectual property rights in any
        submissions made by you or on your behalf in connection with the Website
        (“Licensed Submissions”). You represent and warrant that use by Mari
        Group or its licensees of the Licensed Submissions will not infringe the
        intellectual property rights or other rights of any third party.
      </p>

      <h2>5. Hyperlinks from the Website</h2>
      <p>
        The Website may contain hyperlinks to other websites and webpages
        (“Third-Party Pages”), as well as to text, graphics, videos, images,
        music, sounds, and information belonging to or originating from other
        third-parties (collectively, “Third-Party Applications”). Mari Group
        does not investigate, monitor, or review any Third-Party Pages or
        Third-Party Applications to ensure their accuracy, completeness, or
        appropriateness. Mari Group is not responsible for the Third-Party Pages
        or any Third-Party Applications accessed through the Website. The
        inclusion of any hyperlinks to any Third-Party Pages or Third-Party
        Applications on the Website does not indicate Mari Group’s approval or
        endorsement thereof. If you choose to leave the Website to access any
        Third-Party Pages or Third-Party Applications, you do so at your own
        risk.
      </p>

      <h2>6. No Reliance on Information</h2>
      <p>
        The material and Contents on the Website are provided for general
        information only. It is not intended to amount to advice on which you
        should rely. You must obtain professional or specialist advice before
        taking, or refraining from, any action on the basis of the content on
        the Website. Although Mari Group makes reasonable efforts to update the
        information on the Website, Mari Group makes no representations,
        warranties or guarantees, whether express or implied, that the
        information and/or Contents on the Website is accurate, complete or
        up-to-date.
      </p>

      <h2>7. Liability of Mari Group and Its Licensors and Partners</h2>
      <p>
        The use of the Website and/or the Contents is at your own risk. The
        Contents of the Website could include technical inaccuracies or
        typographical errors. Mari Group may update the Website and/or may
        change the Contents at any time. However, please note that any of the
        Content on the Website may be out of date at any given time, and Mari
        Group is under no obligation to update it. Mari Group does not guarantee
        that the Website, or any of the Contents on it, will be free from errors
        or omissions. Subject to applicable law, Mari Group will not be liable
        to you for any loss or damage, whether in contract, tort (including
        negligence), breach of statutory duty, or otherwise, even if
        foreseeable, arising under or in connection with use or inability to
        use, the Website, or use of or reliance on any Contents displayed on the
        Website. Mari Group will not be liable for any loss or damage caused by
        a virus, distributed denial-of-service attack, or other technologically
        harmful material that may infect your computer equipment, computer
        programs, data or other proprietary material due to your use of the
        Website or to your downloading of any Contents on it, or on any website
        linked to it. Except as otherwise expressly permitted herein, you agree
        not to use the Website for any commercial or business purposes, and
        subject to applicable law Mari Group has no liability to you for any
        loss of profit, loss of business, business interruption, or loss of
        business opportunity arising out of or related to your use, or the
        performance, of the Website. To the extent permitted by applicable law,
        Mari Group excludes all conditions, warranties, representations or other
        terms which may apply to the Website or any Contents on it, whether
        express or implied. Nothing in these Terms of Use excludes or limits
        Mari Group’s liability for death or personal injury arising from
        negligence, or fraud or fraudulent misrepresentation, or any other
        liability that cannot be excluded or limited by applicable law.
      </p>

      <h2>8. Indemnity</h2>
      <p>
        You will be responsible for and will be liable to us and indemnify us
        against any loss or damage suffered by Mari Group as a result of your
        use of the Website or Contents other than as permitted under these Terms
        of Use. You agree to indemnify us in full against any third-party
        liabilities, claims, costs, loss or damage incurred as a result of any
        breach by you of these Terms of Use.
      </p>

      <h2>9. General</h2>
      <p>
        Mari Group makes no claims that the Contents are appropriate or may be
        downloaded outside of the United States of America. Access to the
        Website and Contents may not be legal by certain persons or in certain
        countries. If you access the Website and/or Contents from outside the
        United States, you do so at your own risk and are responsible for
        compliance with the laws of your jurisdiction. The following provisions
        survive the expiration or termination of these Terms of Use for any
        reason whatsoever: Liability of Mari Group and its Licensors and
        Partners, No Reliance on Information, Use Restrictions, Submission of
        Ideas, Indemnity, Viruses, Trademarks, Applicable Laws, Waiver and
        Severability, and Complete Agreement.
      </p>

      <h2>10. Applicable Laws</h2>
      <p>
        Subject to the provisions of applicable law, these Terms of Use are
        governed in accordance with the laws of California, United States of
        America, without regard to its conflict of law provisions. You and Mari
        Group hereby expressly consent and submit to the exclusive jurisdiction
        of the state and federal courts of the County of Los Angeles,
        California, United States of America for the adjudication or disposition
        of any claim, action or dispute arising out of these Terms of Use.
      </p>

      <h2>11. Waiver and Severability</h2>
      <p>
        If any provision of these Terms of Use is found to be invalid by any
        court having competent jurisdiction, the invalidity of such provision
        shall not affect the validity of the remaining provisions of these Terms
        of Use, which shall remain in full force and effect. No waiver of any of
        these Terms of Use shall be deemed a further or continuing waiver of
        such term or condition or any other term or condition.
      </p>

      <h2>12. Notice and Take Down Procedures</h2>
      <p>
        If you believe the Contents (or any part thereof) accessible on or from
        the Website infringes your intellectual property rights, you may request
        removal of those materials (or access thereto) from the Website by
        contacting Mari Group (address identified below) and providing the
        following information:
      </p>
      <ol>
        <li>
          Identification of the work that you believe to be infringed. Please
          describe the work, and where possible include a copy or the location
          (e.g., URL) of an authorized version of the work;
        </li>
        <li>
          Identification of the Content that you believe to be infringing your
          intellectual property rights and its location. Please describe the
          Content, and provide us with its URL or any other pertinent
          information that will allow us to locate the Content;
        </li>
        <li>
          Your name, address, telephone number, and (if available) email
          address;
        </li>
        <li>
          A statement that you have a good faith belief that the complained-of
          use of the work is not authorized by the intellectual property rights
          owner, its agent, or the law;
        </li>
        <li>
          A statement that the information you have supplied is accurate, and
          indicating that “under penalty of perjury,” you are the intellectual
          property rights owner or authorized representative of the intellectual
          property rights owner;
        </li>
        <li>
          A signature or the electronic equivalent from the intellectual
          property rights owner or authorized representative of the intellectual
          property rights owner.
        </li>
      </ol>
      <p>
        Our address for intellectual property rights issues relating to the
        Website is as follows:
      </p>
      <address>
        Mari Group<br />
        Attn: General Counsel<br />
        8383 Wilshire Blvd, Suite 400<br />
        Beverly Hills, CA 90211
      </address>
      <p>
        In an effort to protect the rights of intellectual property rights
        owners, Mari Group maintains a policy for the termination, in
        appropriate circumstances, of users of the Website who are repeat
        infringers.
      </p>

      <h2>13. Trademarks</h2>
      <p>
        Unauthorized use of any Mari Group trademark, service mark or logo is
        prohibited, and may be a violation of federal and state trademark law.
      </p>

      <h2>14. Viruses</h2>
      <p>
        We do not guarantee that the Website will be secure or free from bugs or
        viruses. You are responsible for configuring your information
        technology, computer programs and platform in order to access the
        Website. You should use your own virus protection software. You must not
        misuse the Website by knowingly introducing viruses, trojans, worms,
        logic bombs or other material which is malicious or technologically
        harmful. You must not attempt to gain unauthorized access to the
        Website, the server on which the Website is stored or any server,
        computer or database connected to the Website. You must not attack the
        Website via a denial-of-service attack or a distributed denial-of
        service attack. By breaching this provision, you may be committing a
        criminal offence under applicable law. Mari Group will report any such
        breach to the relevant law enforcement authorities and will co-operate
        with those authorities by disclosing your identity to them. In the event
        of such a breach, your right to use the Website will cease immediately.
      </p>

      <h2>15. Complete Agreement</h2>
      <p>
        Except as expressly provided in a particular notice or disclaimer posted
        by or on behalf of Mari Group on the Website, these Terms of Use,
        including the Mari Group Privacy Policy and Cookie Policy, constitute
        the entire agreement between you and Mari Group with respect to the use
        of the Website and Contents.
      </p>

      <h2>16. Contact Us</h2>
      <p>
        To contact us, please email
        <a href="mailto:contactus@marigrp.com">contactus@marigrp.com</a>.
      </p>
    </div>
  </div>
</section>
